import type { UiTheme } from '@ticarishift/api-client/platform';
import { THEME_PREFERENCES as SHARED_PREFERENCES, applyThemePreference as applyShared, restoreThemePreference } from '@ticarishift/ui';

/**
 * Backoffice'in tema tercihi (S23; 08 §11.10): Açık, Koyu ya da Sistem. Tercihin kaynağı sunucudaki kullanıcı kaydıdır
 * (`GET|PATCH /api/platform/me/ui-preferences`, `GET /api/platform/me` `theme`; panelle aynı kayıt). Uygulama ve ilk
 * boyama panelle ortaktır (`@ticarishift/ui` `theme/preferences.ts` ve `theme-init.js`): depodaki tercih ilk boyamadan
 * önce çözülür ("Sistem" ya da boş depoda işletim sisteminin tercihi), "Sistem" seçiliyken işletim sisteminin tercihi
 * değişince tema da hemen değişir.
 */
export const THEME_PREFERENCES: readonly UiTheme[] = SHARED_PREFERENCES;

/** Tercihi uygular ve depoya yazar; "Sistem" işletim sisteminin tercihini izler. */
export function applyThemePreference(preference: UiTheme) {
  applyShared(preference);
}

export { restoreThemePreference };
